import { AccountStatus } from './AccountStatus';
import type { StatusBadgeProps } from '../../../../shared/components/ui/StatusBadge';

type StatusVariant = NonNullable<StatusBadgeProps['status']>;

export const getStatusVariant = (status: AccountStatus): StatusVariant => {
  switch (status) {
    case 'verified':
      return 'active';
    case 'unverified':
      return 'suspended';
    case 'cancelled':
      return 'revoked';
    case 'removed':
      return 'neutral';
  }
};
